import NCheckbox from './NCheckbox.vue';

export default NCheckbox;